const WLCart = {
    // 組み立て商品削除時の関連商品フラグ更新処理（共通化）
    async updateRelatedBuildOptionFlags(cartData, variantId, excludeVariantIds = []) {
      const item = cartData.items.find(item => item.variant_id.toString() === variantId);
      if (!item || !item.properties._set_key) return;

      const setKey = item.properties._set_key;
      const baseSetKey = setKey.replace('_buildTrue', '');
      
      // 関連する商品を探す（除外リストの商品は除外）
      const relatedItems = cartData.items.filter(item => {
        if (excludeVariantIds.includes(item.variant_id.toString())) return false;
        
        const itemSetKey = item.properties._set_key;
        if (!itemSetKey) return false;
        
        const itemBaseSetKey = itemSetKey.replace('_buildTrue', '');
        return itemBaseSetKey === baseSetKey;
      });
      
      // 関連商品のプロパティを更新
      for (const item of relatedItems) {
        const updatedProperties = { ...item.properties };
        
        // _is_build_optionフラグを削除
        delete updatedProperties._is_build_option;
        
        // _set_keyから_buildTrueサフィックスを削除
        if (updatedProperties._set_key && updatedProperties._set_key.includes('_buildTrue')) {
          updatedProperties._set_key = updatedProperties._set_key.replace('_buildTrue', '');
        }
        
        try {
          await fetch(`${theme.routes.cart_change_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: updatedProperties
            })
          });
        } catch (error) {
          console.error('関連商品フラグ更新エラー:', error);
        }
      }
    },
    buildPriceSKUs: [
      "U90000003000000Z0442",  // 現地組立料（¥4,950）
      "U90000003000000Z0438",  // 現地組立料（¥2,200）
      "U90000003000000Z0439",  // 現地組立料（¥3,300）
      "U90000003000000Z0437",  // 現地組立料（¥1,650）
      "U90000003000000Z0440",  // 現地組立料（¥4,400）
      "U90000003000000Z0441",  // 現地組立料（¥6,600）
      "U90000003000000Z0190",  // 現地組立料（¥1,650）
      "U90000000000000Z0000",  // 現地組立料（¥1,100）
      "U90000003000000Z0022",  // 現地組立料（¥1,650）
      "U90000003000000Z0020",  // 現地組立料（¥1,650）
      "U90000003000000Z0021"   // 現地組立料（テーブル）
    ],
    estimateErrorType1And5Products: [],
    estimateErrorType2And3Products: [],
    estimateErrorType4Products: [],
    estimateErrorType6Products: [],
    shippingCategoryLock: false,

    getSectionsToRender: function() {
      return [
        {
          id: "wl-main-cart-items",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-mini-cart",
          section: document.getElementById("wl-mini-cart") ? document.getElementById("wl-mini-cart").dataset.id : "",
        },
        {
          id: "wl-header",
          section: document.querySelector('unico-header') ? document.querySelector('unico-header').dataset.id : "",
        }
      ];
    },

    renderNewSections: function(sections, updateShippingCategory = true) {
      this.getSectionsToRender().forEach((s) => {
        const oldNode = document.getElementById(s.id);
        if (!oldNode) {
          WLCommon.disableLoading();
          return;
        }
        const newNode = new DOMParser().parseFromString(
          sections[s.section],
          "text/html"
        );
        if (s.id === "wl-header") {
          // oldNode.querySelector('#wishlist-num').innerHTML = newNode.querySelector('#wishlist-num').innerHTML;
          oldNode.querySelector('#cart-num').outerHTML = newNode.querySelector('#cart-num').outerHTML;
        } else if(s.id === "wl-main-cart-items") {
          oldNode.outerHTML = newNode.querySelector(`#${s.id}`).outerHTML;
          // 単品購入の商品だけが残っている場合、削除して画面をリロード
          this.deleteSinglePurchaseAvailableItems();
        } else {
          oldNode.innerHTML = newNode.querySelector(`#${s.id}`).innerHTML;
        }
      });
      if(updateShippingCategory == true) {
        WLCart.addShippingCategory();
      }
      if (this.estimateErrorType1And5Products.length ||
          this.estimateErrorType2And3Products.length ||
          this.estimateErrorType4Products.length ||
          this.estimateErrorType6Products.length) {
        this.showEstimateErrors();
      }
    },

    updateSetQuantity: function(quantity, elem) {
        WLCommon.enableLoading();

        const setKey = elem.closest('[data-set-key]').dataset.setKey;
        const changeQuantity = !quantity ? 0 : parseInt(quantity) / elem.dataset.step;
    
        fetch(`${theme.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((data) => {
            const updateProductObj = {
              updates: {},
              sections: this.getSectionsToRender().map((s) => s.section),
              sections_url: window.location.pathname,
            };
    
            // 親商品と子商品の数量を変更
            data.items.forEach((item) => {
              const properties = item.properties;
              if (properties._set_key === setKey) {
                if (properties._is_parent) {
                  updateProductObj.updates[item.key] = changeQuantity;
                } else if (properties._is_set_product) {
                  updateProductObj.updates[item.key] =
                    item.properties._variant_quantity_step * changeQuantity;
                } else if (properties._is_build_price) {
                  updateProductObj.updates[item.key] = changeQuantity;
                }
              }
            });
    
            const body = JSON.stringify(updateProductObj);
    
            fetch(`${theme.routes.cart_update_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body,
            })
              .then((response) => response.json())
              .then((response) => {
                if(response.errors) {
                  this.updateCartItemsSection(response.errors);
                } else {
                  this.renderNewSections(response.sections);
                  if(location.pathname.includes('/cart')) {
                    window.scrollTo(0, 0);
                  }
                }
              })
              .catch(() => {
                this.errorCartUpdate();
              });
          }).catch(() => {
            this.errorCartUpdate();
          }).finally(() => {
            WLCommon.disableLoading();
          });
    },

    updateBuildPriceTargetQuantity: async function(quantity, elem) {
      try {
        WLCommon.enableLoading();

        const variantId = elem.dataset.variantId;
        const buildPriceId = elem.closest('[data-build-price-target]').dataset.buildPriceTarget;

        // 削除前にカートの現在の状態を取得して関連商品フラグを更新
        if (quantity === 0) {
          const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
          const cartData = await cartResponse.json();
          
          await this.updateRelatedBuildOptionFlags(cartData, variantId, [variantId, buildPriceId]);
        }

        // 削除対象商品と組み立て料金商品の数量を更新
        const body = JSON.stringify({
          updates: {
            [buildPriceId]: quantity,
            [variantId]: quantity,
          },
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        });

        const response = await fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        const responseData = await response.json();
        
        if(responseData.errors) {
          this.updateCartItemsSection(responseData.errors);
        } else {
          this.renderNewSections(responseData.sections);
        }
      } catch (error) {
        this.errorCartUpdate(error);
      } finally {
        WLCommon.disableLoading();
      }
    },

    updateBuildPriceQuantity: async function(quantity, elem) {
      try {
        WLCommon.enableLoading();

        const variantId = elem.dataset.variantId;

        // 削除前にカートの現在の状態を取得
        const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
        const cartData = await cartResponse.json();
        
        // 組み立て料金商品を探す
        const buildPriceItem = cartData.items.find(item => item.variant_id.toString() === variantId);
        if (!buildPriceItem) {
          this.updateQuantity(quantity, elem);
          WLCommon.disableLoading();
          return;
        }

        // 組み立て商品削除時、先に関連する商品のフラグを更新
        if (quantity === 0) {
          await this.updateRelatedBuildOptionFlags(cartData, variantId, [variantId]);
        }

        // 組み立て対象商品のプロパティ更新（対象商品が存在する場合のみ）
        const buildPriceTarget = document.querySelector(`[data-build-price-target="${variantId}"]`);
        if (buildPriceTarget) {
          const targetItem = cartData.items.find(item => item.variant_id.toString() === buildPriceTarget.dataset.variantId);
          if (targetItem) {
            const updateResponse = await fetch(`${theme.routes.cart_change_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                id: buildPriceTarget.dataset.variantId,
                quantity: parseInt(buildPriceTarget.dataset.quantity),
                properties: {
                  ...targetItem.properties,
                  _build_price_target: null
                }
              })
            });
            await updateResponse.json();
          }
        }
        
        // 最後に数量の更新（組み立て料金商品と対象商品の削除）
        await this.updateQuantity(quantity, elem);

      } catch (error) {
        this.errorCartUpdate(error);
      }
    },

    updateQuantity: function(quantity, elem) {
      WLCommon.enableLoading();
      
      const variantKey = elem.dataset.variantKey;
      
      const body = JSON.stringify({
          "updates": {
            [variantKey]: quantity,
          },
          sections: this.getSectionsToRender().map((s) => s.section).filter(n => n),
          sections_url: window.location.pathname,
      });

      fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        if(response.errors) {
          this.updateCartItemsSection(response.errors);
        } else {
          this.renderNewSections(response.sections);
        }
        WLCart.addShippingCategory();
      })
      .catch(() => {
        this.errorCartUpdate();
      })
      .finally(() => {
        WLCommon.disableLoading();
      });
    },

    updateCartItemsSection: function(errors)  {
      const sections = this.getSectionsToRender().map((s) => s.section).join("&sections[]=");
      return fetch(`?${sections}`)
        .then((response) => response.json())
        .then((response) => {
          this.renderNewSections(response);

          if(errors) document.querySelector('[data-modal-target="wl-cart-error-control"]').click();
        })
        .catch((e) => {
          document.querySelector('[data-modal-target="wl-cart-error-control"]').click();
        });
    },

    deleteShippingCategory: function() {
      return new Promise(async (resolve, reject) => {
        if (window.location.pathname.includes("/account/login")) {
          
        }
        WLCommon.disableLoading();
        resolve();
      });
    },
    getCart: () => {
      return new Promise((resolve, reject) => {
        fetch(`${theme.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addShippingCategory: async function(e) {
      if(e) {
        e.preventDefault();
      }
      
      if (this.shippingCategoryLock) {
        console.log('配送区分処理実行中のため待機');
        return;
      }

      this.shippingCategoryLock = true;
      
      try {
        WLCommon.enableLoading();
      const cart = await this.getCart();
      const items = cart.items ? cart.items : [];
      const updateProductObj = {
        updates: {},
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname,
      };
      
      updateProductObj.updates = items.map((item) => {
        if(item.properties && item.properties._shipping_category) {
          return { [item.key]: 0 };
        }
      });
      updateProductObj.updates = updateProductObj.updates.filter((item) => item !== undefined);
      updateProductObj.updates = updateProductObj.updates.reduce((acc, obj) => ({ ...acc, ...obj }), {});
      

      if (Object.keys(updateProductObj.updates).length > 0) {
        const deleteShippingCategoryItems = JSON.stringify(updateProductObj);
        await this.updateCartItems(deleteShippingCategoryItems);
      };    
      
      
      // -------------------------------------
      // ここにカート更新処理を記述
        const itemList = document.querySelectorAll('.unico-cart-list-item');
        let shippingCategories = [];
        const cannotPurchasedSameTimeItems = this.setCannotPurchasedSameTimeItems(itemList);
        const canPurchasedSameTimeItems = this.setCanPurchasedSameTimeItems(itemList);
        // 配列からnullを除外
        const arrayWithoutNulls = canPurchasedSameTimeItems.filter(element => element !== null);

        // 重複を合わせる
        const canPurchasedSameTimeItemsV = this.mergeCanPurchasedSameTimeItems(arrayWithoutNulls);

        // 追加送料単位に分ける
        const shippingUnitCanPurchasedSameTimeItemsVItems = this.mergeAdditionalShippingUnit(canPurchasedSameTimeItemsV);
        console.log("------追加送料単位------");
        // shippingUnitCanPurchasedSameTimeItemsVItems.forEach((item) => console.log(item.properties))

        // 配送区分の統合チェックを実行
        const mergedItems = this.mergeDuplicateShippingCategories([...cannotPurchasedSameTimeItems, ...shippingUnitCanPurchasedSameTimeItemsVItems]);
        
        // 全く同じデータの配送区分の明細が分かれるようにする
        let itemsArr = mergedItems;
        itemsArr = itemsArr.map((item, index) => {
          const itemString = JSON.stringify(item);
          const sameItemIndex = itemsArr.findIndex((i, iIndex) => {
            return JSON.stringify(i) === itemString && index !== iIndex;
          });
          if(sameItemIndex !== -1) {
            item.properties._index = index;
          }
          return item;
        });

        if(itemsArr.length === 0) {
          WLCommon.disableLoading();
          const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
          if (updateModal) {
            updateModal.close();
          }
          return;
        }

        const body = JSON.stringify({
          items: itemsArr,
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        });
  
        fetch(`${theme.routes.cart_add_url}`, {
          ...fetchConfig(),
          ...{ body },
        })
        .then((response) => response.json())
        .then((response) => {
          console.log("---------配送区分の追加実行---------");
          this.renderNewSections(response.sections, false);
          WLCommon.disableLoading();
          setTimeout(() => {
            const submitButton = document.querySelector('.unico-submit-button')
            const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
            if(submitButton) {
              submitButton.disabled = false;
              document.querySelectorAll('.unico-cart-list-item-button-area unico-counter-box').forEach((counter) => {
                counter.classList.remove('loading');
                WLCartUpdate.init();
              });
            }
            if(updateModal) {
              updateModal.close();
            }
          }, 1000);
          
        }).catch((error) => {
          WLCommon.disableLoading();
          console.log("---------配送区分の追加失敗---------");
          console.error("カート更新失敗", error);
        })
      } finally {
        this.shippingCategoryLock = false;
      }
    },
    updateCartItems: function(body) {
      return new Promise((resolve, reject) => {
        fetch(`/cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body,
        })
        .then((response) => response.json())
        .then((response) => {
          console.log("---------配送区分の削除---------");
          resolve();
        })
        .catch(() => {
          console.log("---------配送区分の削除失敗---------");
          this.errorCartUpdate();
        });
      });
    },
    mergeCanPurchasedSameTimeItems: (canPurchasedSameTimeItems) => {
      return canPurchasedSameTimeItems.reduce((acc, item) => {
        // 既存のアイテムを見つける
        const existingItem = acc.find(
            (i) =>
                i.properties._shipping_size === item.properties._shipping_size &&
                i.properties._shipping_vendor_code === item.properties._shipping_vendor_code &&
                i.properties._cannot_purchased_same_time === item.properties._cannot_purchased_same_time &&
                !item.properties._additional_shipping_unit

        );
        if (existingItem) {
            // 既存のアイテムに対して処理をまとめる
            existingItem.properties["_target_variant_id"] += ',' + item.properties["_target_variant_id"];
            existingItem.properties["対象商品"] += ` / ${item.properties["対象商品"]}`; 
            existingItem.properties["_target_variant_count"] += ',' + item.properties["_target_variant_count"];
        } else {
            // 新しいアイテムとして追加
            acc.push({ ...item });
        }
    
        return acc;
      }, []);
    },
    mergeAdditionalShippingUnit: (items) => {
      return items.reduce((acc, item) => {
        if(!item.properties._additional_shipping_unit) {
          acc.push({...item});
          return acc;
        }
        const targetVariantCount = Number(item.properties._target_variant_count);
        const additionalShippingUnit = Number(item.properties._additional_shipping_unit);
        
        if (targetVariantCount > additionalShippingUnit) {
          const additionalShippingUnitCount = Math.ceil(targetVariantCount / additionalShippingUnit);
          let count = targetVariantCount;
          for (let i = 0; i < additionalShippingUnitCount; i++) {
            const newItem = { ...item, properties: { ...item.properties } };
            newItem.properties._index = i;
            newItem.properties._separated = true;
            newItem.properties._target_variant_count = count / additionalShippingUnit > 1 ? additionalShippingUnit : count; 
            acc.push(newItem);
            count -= additionalShippingUnit;
          }
          return acc
        } else {
          acc.push({...item});
          return acc;
        }
      }, []);
    },
    setCannotPurchasedSameTimeItems: (itemList) => {
      return Array.from(itemList).flatMap((item, index) => {
        if (item.dataset.shippingCategoryId && ( !item.dataset.cannotPurchasedSameTime || item.dataset.cannotPurchasedSameTime === 'false' )) {
          return Array.from({ length: parseInt(item.dataset.quantity, 10) }, (_, i) => ({
            id: item.dataset.shippingCategoryId,
            quantity: 1,
            properties: {
              _index: i,  // 1から始まるインデックス
              _shipping_category: true,
              _target_variant_id: item.dataset.lineItemKey,
              _shipping_size: item.dataset.shippingSize,
              _shipping_vendor_code: item.dataset.shippingVendorCode.trim(),
              _cannot_purchased_same_time: item.dataset.cannotPurchasedSameTime,
              _target_variant_count: 1,
              "対象商品": item.dataset.productTitle
            }
          }));
        }
        return [];  // 条件に合わない場合は空配列を返す
      });
    },
    setCanPurchasedSameTimeItems: (itemList) => {
      return Array.from(itemList).map((item) => {
        if (item.dataset.shippingCategoryId && item.dataset.cannotPurchasedSameTime === 'true') {
          // 条件に合致しない場合、新しいオブジェクトを返す
          return {
            id: item.dataset.shippingCategoryId,
            quantity: 1,
            properties: {
              _index: 0,
              _shipping_category: true,
              _target_variant_id: item.dataset.lineItemKey,
              _shipping_size: item.dataset.shippingSize,
              _shipping_vendor_code: item.dataset.shippingVendorCode.trim(),
              _cannot_purchased_same_time: item.dataset.cannotPurchasedSameTime,
              _additional_shipping_unit: item.dataset.additionalShippingUnit,
              _target_variant_count: item.dataset.quantity,
              "対象商品": item.dataset.productTitle
            }
          };
        }
        return null; 
      });
    },
    errorCartUpdate: (error) => {
      WLCommon.disableLoading();
      console.error("カート更新失敗", error);
    },
    removeCustomOrderChildItems: function(elem, json) {
      WLCommon.enableLoading();
      const updateProductObj = {
        updates: {},
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname,
      };
      updateProductObj.updates[elem.dataset.variantKey] = 0;
      for (const value of json) {
        updateProductObj.updates[value[0]] = value[1];
      }

      const body = JSON.stringify(updateProductObj);

      fetch(`${theme.routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body },
      })
      .then((response) => response.json())
      .then((response) => {
        this.renderNewSections(response.sections);
      })
      .catch(() => {
        this.errorCartUpdate();
      })
      .finally(() => {
        WLCommon.disableLoading();
      })

    },

    deleteSinglePurchaseAvailableItems: async function() {
      const cartItems = document.querySelectorAll('.unico-cart-list-item');
      const singlePurchaseAvailableVariantIds = Array.from(cartItems).reduce((acc, item) => {
        const isSinglePurchaseAvailable = item.dataset.singlePurchaseAvailable;
        if (isSinglePurchaseAvailable === 'false' && item.dataset.setKey === 'false' ) {
          acc.push(item.dataset.variantId);
        }
        return acc;
      }, []);
      const otherItems = Array.from(cartItems).reduce((acc, item) => {
        const isSinglePurchaseAvailable = item.dataset.singlePurchaseAvailable;
        if (isSinglePurchaseAvailable === 'true' || item.dataset.setKey !== 'false') {
          acc.push(item.dataset.variantId);
        }
        return acc;
      }, []);

      if(otherItems.length === 0 && singlePurchaseAvailableVariantIds.length > 0) {
        WLCommon.enableLoading();
        const updateProductObj = {
          updates: {},
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        };
        updateProductObj.updates[singlePurchaseAvailableVariantIds[0]] = 0;
        const updateResponse = await fetch(`${theme.routes.cart_update_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(updateProductObj),
        }).then((res) => res.json());
        
        this.renderNewSections(updateResponse.sections);
        WLCommon.disableLoading();
      }
    },

    addEstimateItems: async function (estimateNo) {
      try { 
        const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
        if (updateModal) {
          updateModal.showModal();
        }
    
        // 見積番号から見積情報を取得
        const url = '/apps/unico-custom-app/store-estimate';
        const response = await fetch(url, {
          method: "POST",
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({estimate_code: estimateNo}),
        }).then((res) => res.json())

        // エラーチェック
        if (response.error.length) {
          response.error.sort((a, b) => a.type - b.type);
    
          for (const error of response.error) {
            switch (error.type) {
              case 1:
                document.querySelector('#estimate-error-box-type1').style.display = 'block';
                this.estimateErrorType1And5Products.push(error.product_code);
                return;
    
              case 2:
              case 3:
                this.estimateErrorType2And3Products.push(error.product_code);
                break;
    
              case 4:
                this.estimateErrorType4Products.push(error.product_code);
                break;

              case 5:
                document.querySelector('#estimate-error-box-type4').style.display = 'block';
                this.estimateErrorType1And5Products.push(error.product_code);
                return;

              case 6:
                this.estimateErrorType6Products.push(error.product_code);
                break;

            }
          }
        }
    
        if (response.product.length) {
          // 既存の見積情報がカートに入っている場合、削除
          const cartData = await fetch(`${theme.routes.cart_url}.js`).then((res) => res.json());
    
          const updateProductObj = {
            updates: {}
          };
          const updateProductIds = [];
          
          cartData.items.forEach((item) => {
            if (item.properties && item.properties._estimate_code) {
              updateProductObj.updates[item.key] = 0;
              updateProductIds.push(item.variant_id.toString());
            }
          });

          // 付随するギフト商品も削除
          cartData.items.forEach((item) => {
            if (item.properties && item.properties._is_gift_item && updateProductIds.includes(item.properties._target_product_id)) {
              updateProductObj.updates[item.key] = 0;
            }
          });
    
          if (Object.keys(updateProductObj.updates).length > 0) {
            const body = JSON.stringify(updateProductObj);
            const updateResponse = await fetch(`${theme.routes.cart_update_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body,
            }).then((res) => res.json());
            console.log("既存の見積削除");
            console.log(updateResponse.items);
          }
          
          // 新しい見積情報をカートに追加
          const estimateItems = response.product
            .filter(product => !this.buildPriceSKUs.includes(product.product_code)) // 現地組立料を除外
            .map((product, index) => ({
              id: product.variant_id,
              quantity: product.quantity,
              properties: {
                _estimate_code: estimateNo,
                _estimate_line_number: product.line_number,
                "見積番号": estimateNo,
              },
            }));
          
          // estimateItemsが空の場合は処理を終了
          if (estimateItems.length === 0) {
            console.log("見積連携：追加する商品がありません");
            this.showEstimateErrors();
            // URLパラメータの?estimate=をURLから削除
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('estimate');
            window.history.replaceState({}, '', newUrl);
            return;
          }
          
          const body = JSON.stringify({
            items: estimateItems,
            sections: this.getSectionsToRender().map((s) => s.section),
            sections_url: window.location.pathname,
          });
          
          const addResponse = await fetch(`${theme.routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body,
          }).then((res) => res.json());
          console.log("新規の見積追加");
          console.log(addResponse.items);

          const buildPriceItems = [];
          Object.values(addResponse.sections).forEach(sectionHtml => {
            const template = document.createElement('template');
            template.innerHTML = sectionHtml;
            const buildItems = template.content.querySelectorAll('.unico-cart-list-item[data-estimate-build-variant-id]');
            buildPriceItems.push(...Array.from(buildItems));
          });

          // 組立料金の追加処理
          if (buildPriceItems.length > 0) {
            const buildPriceVariants = Array.from(buildPriceItems).map(item => ({
              id: item.dataset.estimateBuildVariantId,
              quantity: 1,
              properties: {
                _estimate_code: estimateNo,
                _is_build_price: true,
                _variant_id: item.dataset.estimateBuildVariantId,
                "見積番号": estimateNo,
                "対象商品": item.dataset.productTitle,
              },
            }));

            const buildPriceBody = JSON.stringify({
              items: buildPriceVariants,
              sections: this.getSectionsToRender().map((s) => s.section),
              sections_url: window.location.pathname,
            });

            const buildPriceResponse = await fetch(`${theme.routes.cart_add_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: buildPriceBody,
            }).then((res) => res.json());
            console.log("組立料金の追加");
            console.log(buildPriceResponse.items);


            // 組立料金の対象商品に_build_price_targetを追加
            const buildPriceTargetIdAndVariantId = buildPriceItems.map((item) => ({
              _id: item.dataset.variantId, // 組立対象商品のvariantId
              _build_price_target_id: item.dataset.estimateBuildVariantId // 組立料金自身のvariantId
            }));

            const updateEstimateItemsProperties = async (buildPriceTargetIdAndVariantId) => {
              for (let item of buildPriceTargetIdAndVariantId) {

                const estimateItem = estimateItems.find((estimateItem) => estimateItem.id === item._id);
                // estimateItemが見つからない場合はスキップ
                if (!estimateItem) {
                  console.warn(`estimateItem not found for id: ${item._id}`);
                  continue;
                }
                const estimateItemProperties = estimateItem.properties;
                estimateItemProperties._build_price_target = item._build_price_target_id;

                const response = await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: item._id, 
                    quantity: item.quantity,
                    properties: estimateItemProperties
                  })
                });

                if (!response.ok) {
                  this.errorCartUpdate(response);
                  return;
                }
              }
            };

            await updateEstimateItemsProperties(buildPriceTargetIdAndVariantId);

            const sections = this.getSectionsToRender().map((s) => s.section).join("&sections[]=");
            const sectionsResponse = await fetch(`?sections[]=${sections}`).then((res) => res.json());
            this.renderNewSections(sectionsResponse);
          } else {
            this.renderNewSections(addResponse.sections);
          }
        } else {
          this.showEstimateErrors();
        }

        // URLパラメータの?estimate=をURLから削除
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('estimate');
        window.history.replaceState({}, '', newUrl);
        
      } catch (error) {
        this.errorCartUpdate(error);
        alert("見積情報の取得に失敗しました");
      } finally {
        const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
        if (updateModal) {
          updateModal.close();
        }
        WLCommon.disableLoading();
        return;
      }
    },
    
    checkEstimateProductPreOrder: async function() {
      if(this.estimateErrorType1And5Products.length) return;

      WLCommon.enableLoading();

      const cartItems = document.querySelectorAll('.unico-cart-list-item');

      const updateItems = [];

      cartItems.forEach((item) => {
        const json = item.querySelector('script[type="application/json"]');
        if (!json) return;
        const variantData = JSON.parse(json.innerHTML);
        
        // カートアイテムのkeyを取得（/cart/change.jsにはkeyが必要）
        const itemKey = item.dataset.lineItemKey;
        if (!itemKey) {
          console.warn('カートアイテムのkeyが見つかりません:', item);
          return;
        }
        
        // 予約商品かどうかをチェック
        if ((variantData.quantity > 0) ||
              (variantData.quantity <= 0 && variantData.inventory_policy !== 'continue') ||
              (!variantData.stock_date || !variantData.delivery_buffer)) {
          return;
        }
  
        const today = new Date();
        let quantity = variantData.quantity;
        variantData.stock_date.sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        });
        for (let i = 0; i < variantData.stock_date.length; i++) {
          const stockDate = new Date(variantData.stock_date[i].date);
  
          if (!this.isNowDateAheadOfStockDate(today, stockDate)) continue;
          const stockAmount = variantData.stock_date[i].amount;
  
          quantity += stockAmount;
          if (quantity > 0) {
            const deliveryDate = this.getDeliveryDate(stockDate, variantData);
            const stockDateString = `${stockDate.getFullYear()}年${
              stockDate.getMonth() + 1
            }月${this.getDatePeriod(stockDate)}`;

            // 既存のプロパティを取得（配列形式またはオブジェクト形式に対応）
            let oldProperties = {};
            if (Array.isArray(variantData.properties)) {
              // 配列形式の場合
              oldProperties = variantData.properties.reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
              }, {});
            } else if (variantData.properties && typeof variantData.properties === 'object') {
              // オブジェクト形式の場合
              oldProperties = { ...variantData.properties };
            }
            
            const newProperties = {
              _pre_order: true,
              _stock_date: stockDateString,
              _delivery_date: deliveryDate
            };
            // 既存のプロパティを保持しつつ、予約情報を追加
            const mergedProperties = { ...oldProperties, ...newProperties };

            updateItems.push({
              id: itemKey, // カートアイテムのkeyを使用
              properties: mergedProperties,
              quantity: item.dataset.quantity,
            });
            break;
          }
        }
        if (quantity <= 0) {
          return;
        }
      });

      if (Object.keys(updateItems).length === 0) {
        WLCommon.disableLoading();
        return;
      }

      // 既存のupdateCartItemsProperties関数を活用
      await this.updateCartItemsProperties(updateItems);

      const sections = this.getSectionsToRender().map((s) => s.section).join("&sections[]=");
      const sectionsResponse = await fetch(`?sections[]=${sections}`).then((res) => res.json());
      this.renderNewSections(sectionsResponse);
    
      WLCommon.disableLoading();
    },

    // 既存のupdateCartItemsProperties関数を独立した関数として抽出
    updateCartItemsProperties: async function(updateItems) {
      // すべてのアイテムを順次更新
      for (let item of updateItems) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: item.id, 
            quantity: item.quantity,
            properties: item.properties
          })
        });

        if (!response.ok) {
          this.errorCartUpdate(response);
          return;
        }

        await response.json();
      }

      // すべてのアイテム更新が完了したら、1回だけセクション情報を取得して更新
      // これにより、リロードのような挙動を避けつつ、必要な部分だけを更新
      const sections = this.getSectionsToRender().map((s) => s.section).join("&sections[]=");
      const sectionsResponse = await fetch(`?sections[]=${sections}`).then((res) => res.json());
      this.renderNewSections(sectionsResponse);
    },

    // 既存のupdateCartItemsProperties関数を活用して予約商品情報を追加
    addPreOrderInfoToEstimateItems: async function() {
      // エラーがある場合は処理をスキップ
      if(this.estimateErrorType1And5Products.length) return;

      try {
        WLCommon.enableLoading();

        // 1. カート内の見積商品を取得
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const estimateItems = cart.items.filter(item => 
          item.properties && item.properties._estimate_code
        );

        if (estimateItems.length === 0) {
          WLCommon.disableLoading();
          return;
        }

        // 2. 各見積商品に対して予約商品情報を計算
        const updateItems = [];
        
        for (const item of estimateItems) {
          const preOrderInfo = await this.calculatePreOrderInfo(item);
          
          if (Object.keys(preOrderInfo).length > 0) {
            // 既存のプロパティを取得（配列形式またはオブジェクト形式に対応）
            let existingProperties = {};
            if (item.properties) {
              if (Array.isArray(item.properties)) {
                // 配列形式の場合（Liquidテンプレートから来た場合）
                existingProperties = item.properties.reduce((acc, [key, value]) => {
                  acc[key] = value;
                  return acc;
                }, {});
              } else if (typeof item.properties === 'object') {
                // オブジェクト形式の場合（APIから来た場合）
                existingProperties = { ...item.properties };
              }
            }
            
            // 既存のプロパティを保持しつつ、予約情報を追加
            const mergedProperties = {
              ...existingProperties,
              ...preOrderInfo
            };
            
            updateItems.push({
              id: item.key, // カートアイテムのkeyを使用
              properties: mergedProperties,
              quantity: item.quantity,
            });
          }
        }

        // 3. 既存のupdateCartItemsProperties関数を活用
        if (updateItems.length > 0) {
          await this.updateCartItemsProperties(updateItems);
        }

      } catch (error) {
        console.error('見積商品の予約情報追加エラー:', error);
        this.errorCartUpdate(error);
      } finally {
        WLCommon.disableLoading();
      }
    },

    // 予約商品情報を計算する関数
    calculatePreOrderInfo: async function(item) {
      try {
        // 商品の詳細情報を取得してメタフィールドデータを取得
        const productResponse = await fetch(`/products/${item.product_id}.js`);
        
        // レスポンスのステータスをチェック
        if (!productResponse.ok) {
          console.warn(`商品API取得失敗: ${productResponse.status}`);
          return {};
        }
        
        const product = await productResponse.json();
        
        // 商品データの存在チェック
        if (!product || !product.variants) {
          console.warn('商品データが無効です');
          return {};
        }
        
        const variant = product.variants.find(v => v.id === item.variant_id);
        if (!variant) {
          console.warn(`バリアントが見つかりません: ${item.variant_id}`);
          return {};
        }

        // メタフィールドから予約商品関連のデータを取得
        const stockDate = variant.metafields?.unico?.stock_date || [];
        const deliveryBuffer = variant.metafields?.unico?.delivery_buffer || null;
        const inventoryPolicy = variant.inventory_policy || 'deny';
        const inventoryQuantity = variant.inventory_quantity || 0;

        // 予約商品かどうかをチェック
        if ((inventoryQuantity > 0) ||
              (inventoryQuantity <= 0 && inventoryPolicy !== 'continue') ||
              (!stockDate || stockDate.length === 0 || !deliveryBuffer)) {
          return {};
        }

        const today = new Date();
        let quantity = inventoryQuantity;
        
        if (stockDate && stockDate.length > 0) {
          stockDate.sort((a, b) => {
            return new Date(a.date) - new Date(b.date);
          });
          
          for (let i = 0; i < stockDate.length; i++) {
            const stockDateItem = new Date(stockDate[i].date);
    
            if (!this.isNowDateAheadOfStockDate(today, stockDateItem)) continue;
            const stockAmount = stockDate[i].amount;
    
            quantity += stockAmount;
            if (quantity > 0) {
              const deliveryDate = this.getDeliveryDate(stockDateItem, { delivery_buffer: deliveryBuffer });
              const stockDateString = `${stockDateItem.getFullYear()}年${
                stockDateItem.getMonth() + 1
              }月${this.getDatePeriod(stockDateItem)}`;

              return {
                _pre_order: true,
                _stock_date: stockDateString,
                _delivery_date: deliveryDate
              };
            }
          }
        }

        return {};
      } catch (error) {
        console.error('予約商品情報の計算エラー:', error);
        return {};
      }
    },

    isNowDateAheadOfStockDate: function(nowDate, stockDate) {
      return this.convertDateToPeriodStart(nowDate).getTime() < this.convertDateToPeriodStart(stockDate).getTime();
    },

    convertDateToPeriodStart: function(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      let newDay = day <= 10 ? 1 : (day <= 20 ? 11 : 21);
      return new Date(year, month, newDay);
    },

    getDeliveryDate: function(date, currentVariant) {
      let deliveryDate = new Date(date);
      if (currentVariant.delivery_buffer.key === 'month') {
          deliveryDate.setMonth(deliveryDate.getMonth() + Number(currentVariant.delivery_buffer.period));
      } else if (currentVariant.delivery_buffer.key === 'date') {
          deliveryDate.setDate(deliveryDate.getDate() + Number(currentVariant.delivery_buffer.period));
      }

      let year = deliveryDate.getFullYear().toString();
      let month = (deliveryDate.getMonth() + 1).toString();
      let settingsDeliveryText = this.getDatePeriod(deliveryDate);

      return `${year}年${month}月${settingsDeliveryText}`;
    },

    getDatePeriod: function(date) {
      const day = date.getDate();
      return day <= 10 ? "上旬" : day <= 20 ? "中旬" : "下旬";
    },

    showEstimateErrors: function() {
      if (this.estimateErrorType2And3Products.length) {
        document.querySelector('#estimate-error-message-type2').innerText = document
          .querySelector('#estimate-error-message-type2')
          .innerText.replace('[productNumber]', this.estimateErrorType2And3Products.join(', '));
        document.querySelector('#estimate-error-box-type2').style.display = 'block';
      }

      if (this.estimateErrorType4Products.length) {
        document.querySelector('#estimate-error-message-type3').innerText = document
          .querySelector('#estimate-error-message-type3')
          .innerText.replace('[productNumber]', this.estimateErrorType4Products.join(', '));
        document.querySelector('#estimate-error-box-type3').style.display = 'block';
      }
      if (this.estimateErrorType6Products.length) {
        document.querySelector('#estimate-error-message-type6').innerText = document
          .querySelector('#estimate-error-message-type6')
          .innerText.replace('[productNumber]', this.estimateErrorType6Products.join(', '))
          .replace(/\s+/g, ' ');
        document.querySelector('#estimate-error-box-type6').style.display = 'block';
      }
    },
    mergeDuplicateShippingCategories: (items) => {
      return items.reduce((acc, item) => {
        // 既存のアイテムを見つける（順番を無視して全く同じ内容かチェック）
        const existingItem = acc.find((existing) => {
          // 基本プロパティの比較
          if (existing.id !== item.id ||
              existing.quantity !== item.quantity) {
            return false;
          }

          // propertiesの比較（順番を無視）
          const existingProps = existing.properties;
          const newProps = item.properties;

          // プロパティのキーが同じかチェック
          const existingKeys = Object.keys(existingProps).sort();
          const newKeys = Object.keys(newProps).sort();
          if (existingKeys.join(',') !== newKeys.join(',')) {
            return false;
          }

          // 各プロパティの値を比較（順番を無視）
          for (const key of existingKeys) {
            const existingValue = existingProps[key];
            const newValue = newProps[key];

            // 配列やカンマ区切り文字列の場合は正規化して比較
            if (typeof existingValue === 'string' && typeof newValue === 'string') {
              if (existingValue.includes(',') || existingValue.includes(' / ')) {
                // カンマ区切りまたはスラッシュ区切りの場合は正規化
                const existingNormalized = existingValue.split(/[,/]/).map(v => v.trim()).sort().join(',');
                const newNormalized = newValue.split(/[,/]/).map(v => v.trim()).sort().join(',');
                if (existingNormalized !== newNormalized) {
                  return false;
                }
              } else {
                // 通常の文字列比較
                if (existingValue !== newValue) {
                  return false;
                }
              }
            } else {
              // その他の型の比較
              if (existingValue !== newValue) {
                return false;
              }
            }
          }

          return true;
        });

        if (!existingItem) {
          // 新しいアイテムとして追加
          acc.push({ ...item });
        } else {
          console.log("既存のアイテムが見つかったので1つに統合");
          console.log(existingItem);
          console.log(item);
        }
        // 既存のアイテムが見つかった場合は何もしない（1つだけ残す）
        return acc;
      }, []);
    },

};

window.WLCart = WLCart;

// グローバル関数として公開（他のファイルから参照されるため）
window.isNowDateAheadOfStockDate = function(nowDate, stockDate) {
  return WLCart.isNowDateAheadOfStockDate(nowDate, stockDate);
};

window.convertDateToPeriodStart = function(date) {
  return WLCart.convertDateToPeriodStart(date);
};

window.getDeliveryDate = function(date, currentVariant) {
  return WLCart.getDeliveryDate(date, currentVariant);
};

window.getDatePeriod = function(date) {
  return WLCart.getDatePeriod(date);
};

document.addEventListener("DOMContentLoaded", function() {
  WLCart.deleteShippingCategory().then(() => {
    // 見積機能
    const urlParams = new URLSearchParams(window.location.search);
    if(!urlParams.has('estimate')) return;
      WLCart.addEstimateItems(urlParams.get('estimate')).then(() => {
        // 修正：DOM操作に依存しない新しい関数を使用
        WLCart.addPreOrderInfoToEstimateItems();
      });
    });
});
